import { Injectable } from '@angular/core';
import { BinaryWriter } from 'google-protobuf';
import { MenuAlias } from '../../../libs/proto/commUnity_pb';

@Injectable({
  providedIn: 'root'
})
export class MenuAliasConversionService {

  constructor() { }

  ToStorage(req: MenuAlias) {
    const w = new BinaryWriter();
    MenuAlias.serializeBinaryToWriter( req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }

  FromStorage(data: any, callback: (MenuAlias: MenuAlias, errorConvert: any) => void) {
    try {
      callback( MenuAlias.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }
}
